export default __webpack_public_path__ + "static/media/299.24f75077.jpg";